import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import moment from 'moment'

import { ReactComponent as SignIcon } from 'assets/icons/sign.svg'
import { DATE_SHORT } from 'utils/formatters/date'
import { formatFullNameWithMiddleInitialFirst } from 'utils/formatters/user'
import { Text } from 'components/text/Text'

import styles from './SignDigital.module.scss'

export const SignDigital = ({ className, isSigned, isDisabled = false, dateSign, user, signCallback }) => (
  <div data-test-id="sign-digital" className={classNames(styles.signDigital, className)}>
    {isSigned ? (
      <Text>
        Signed by&nbsp;
        <b>{formatFullNameWithMiddleInitialFirst(user)}</b>
        {dateSign && (
          <Fragment>
            &nbsp;on <b>{moment(dateSign).format(DATE_SHORT)}</b>
          </Fragment>
        )}
      </Text>
    ) : (
      <div className={classNames({ [styles.disabled]: isDisabled })}>
        <span onClick={() => signCallback && signCallback(true)} className={styles.signButton}>
          <SignIcon className={styles.signIcon} /> <span>Sign Digitally</span>
        </span>
      </div>
    )}
  </div>
)

SignDigital.propTypes = {
  className: PropTypes.string,
  dateSign: PropTypes.string,
  isSigned: PropTypes.bool,
  isDisabled: PropTypes.bool,
  user: PropTypes.object.isRequired,
  signCallback: PropTypes.func,
}
